'use strict';
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.mq = void 0;
/* eslint-disable sort-keys-fix/sort-keys-fix */
const facepaint_1 = __importDefault(require('facepaint'));
const config_1 = require('./utils/config');
exports.mq = (0, facepaint_1.default)(
  Object.values(config_1.breakpoints).map(bp => `@media (min-width: ${bp}px)`),
  { overlap: true }
);
//# sourceMappingURL=Breakpoints.Styled.js.map
